export default __webpack_public_path__ + "static/media/mobile-plan.45fcf6b9.svg";